// Lib
import { clicksConfig } from '@/lib/analytics/kpis/pinterest/clicks';

// Components
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { KPIDefault } from '@/components/base/Kpi/KpiDefault';

// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';

export const mediaViewerClicksConfig: KpiType<typeof MediaViewerKpiLoader, typeof KPIDefault> = {
    ...clicksConfig,
    tooltip: null,
    loader: MediaViewerKpiLoader
};
